import appendScript from './appendScript';
let hasAppendedCBSTritonScript = false;

export default function ifThenAppendCBSTritonScript() {
  if (hasAppendedCBSTritonScript) return false;
  appendScript('https://playerservices.live.streamtheworld.com/api/idsync.js');
  hasAppendedCBSTritonScript = true;
  return true;
}
